import { supabase } from '../supabaseClient'

// Proceso controlado de deportes por organizacion (spec 2026-10-01). Todo pasa por
// funciones de la base que exigen Platform Admin; aqui solo se llaman.

// La tabla de la pantalla: { plan, tope, deportes: [{ deporte_id, nombre, catalogo_activo,
// habilitado, grupos, categorias, jugadores }] }, habilitados primero.
export const getDeportesDeOrg = async (orgId) => {
  const { data, error } = await supabase.rpc('deportes_de_org', { p_org_id: orgId })
  return { data, error }
}

export const getImpactoDeporte = async (orgId, deporteId) => {
  const { data, error } = await supabase.rpc('deporte_impacto', { p_org_id: orgId, p_deporte_id: deporteId })
  return { data, error }
}

export const deshabilitarDeporteOrg = async ({ orgId, deporteId, motivo, confirmacion }) => {
  const { data, error } = await supabase.rpc('deshabilitar_deporte_org', {
    p_org_id: orgId, p_deporte_id: deporteId, p_motivo: motivo, p_confirmacion: confirmacion,
  })
  return { data, error }
}

export const habilitarDeporteOrg = async ({ orgId, deporteId, motivo }) => {
  const { data, error } = await supabase.rpc('habilitar_deporte_org', {
    p_org_id: orgId, p_deporte_id: deporteId, p_motivo: motivo,
  })
  return { data, error }
}

export const getBitacoraDeportes = async (orgId) => {
  const { data, error } = await supabase
    .from('org_deportes_bitacora')
    .select('id, deporte_id, accion, motivo, created_at, cerrado, restaurado, autor:hecho_por(nombre_completo), deporte:deporte_id(nombre)')
    .eq('org_id', orgId)
    .order('created_at', { ascending: false })
  return { data: data || [], error }
}
